import { Injectable } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service';
import { ConstantsStore } from '../constants.store';
import { Event } from 'src/app/models/event';
import { colors } from 'src/app/shared/calendar-view-week/utils/colors';
import { FormGroup } from '@angular/forms';
import { addHours } from 'date-fns';
import { take } from 'rxjs/operators';
import { Helpers } from 'src/app/models/Helpers/helpers';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  events: CalendarEvent<{ description: string }>[];

  constructor(
    private apiService: ApiService,
    private constants: ConstantsStore
  ) {
    this.events = [];
  }

  getEvents(): Observable<any> {
    return new Observable(observer => {
      this.apiService.get<Event[]>(this.constants.eventsUrl)
        .pipe(take(1))
        .subscribe(
          eventsFromDb => {
            eventsFromDb.forEach(event => {
              this.addToCalendarEvents(event);
            });

            // console.log('LOADED EVENTS FROM DB');
            // console.log(this.events);

            observer.next();
          },
          error => {
            observer.error(error);
          }
        );
    });
  }

  postNewEvent(newEvent: Event): Observable<any> {
    return new Observable(observer => {
      this.apiService.post(this.constants.eventsUrl, newEvent)
        .subscribe(
          insertedEvent => {
            observer.next(insertedEvent);
          },
          error => {
            observer.error(error);
          }
        );
    });
  }

  deleteEvent(eventId: number) {
    return new Observable(observer => {
      this.apiService.delete(this.constants.eventsUrl, eventId)
        .subscribe(
          () => {
            observer.next();
          },
          error => {
            observer.error(error);
          }
        );
    });
  }


  public addToCalendarEvents(eventFromDb: Event) {
    let eventStart: Date;
    let eventEnd: Date;

    eventStart = new Date(eventFromDb.eventStart);
    eventEnd = new Date(eventFromDb.eventEnd);

    // console.log('NEW DATE EFFECTS: ');
    // console.log(`${eventFromDb.eventStart} --VS-- ${eventStart}`); // * dal db l'ora mi arriva in questo formato 2020-09-05T10:00:00Z (con la Z) e, quando faccio new Date con quella data, mi viene convertito nell'Ora legale dell'europa Centrale -> Sat Sep 05 2020 12:00:00 GMT+0200 (Ora legale dell’Europa centrale)
    // console.log(`${eventFromDb.eventEnd} --VS-- ${eventEnd}`);

    const newEvent = {
      id: eventFromDb.id,
      start: eventStart,
      end: eventEnd,
      title: `${eventFromDb.title}`,
      color: colors.orange,
      cssClass: 'custom-event',
      meta: {
        description: eventFromDb.description
      }
    };

    this.events.push(newEvent);
  }
  public deleteEventFromStore(eventId: number): void {
    //console.log('BEFORE', this.events);
    const eventToDeleteIndex = this.events.findIndex(event => event.id === eventId);
    this.events.splice(eventToDeleteIndex, 1);
    //console.log('AFTER', this.events);
  }

  public convertToEvent(form: FormGroup): Event {
    const startingTimeData = form.value.startingTime.split(':');
    const endTimeData = form.value.endTime.split(':');

    const eventStart = new Date(form.value.date);
    eventStart.setHours(startingTimeData[0], startingTimeData[1], 0, 0);

    const eventEnd = new Date(form.value.date);
    eventEnd.setHours(endTimeData[0], endTimeData[1], 0, 0);

    return {
      id: 0,
      title: form.value.title,
      eventStart: Helpers.convertDateToLocalFormat(eventStart),
      eventEnd: Helpers.convertDateToLocalFormat(eventEnd),
      description: form.value.description
    };
  }
  public searchEventById(eventId: number): CalendarEvent<{ description: string }> {
    const eventIndex = this.events.findIndex(event => Number(event.id) === eventId);
    const searchedEvent = this.events[eventIndex];
    const eventCopy = JSON.parse(JSON.stringify(searchedEvent));
    return eventCopy;
  }
}
